'use client'
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Link from 'next/link';

export default function Servicos() {
  return (
    <main className="min-h-screen flex flex-col">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-teal-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-6">Serviços Especializados</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Oferecemos tratamentos personalizados para diversas condições, com foco em reabilitação neurológica e física.
            </p>
          </div>
        </div>
      </section>
      
      {/* Services List */}
      <section className="py-16 bg-white" id="avaliacao">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Avaliação Inicial</h2>
              <p className="text-lg text-gray-600 mb-4">
                A avaliação inicial é o primeiro passo para um tratamento eficaz. Durante esta sessão, realizamos uma análise detalhada da sua condição, histórico médico e objetivos.
              </p>
              <p className="text-lg text-gray-600 mb-4">
                Esta avaliação inclui:
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-600 space-y-2">
                <li>Análise do histórico médico e condições atuais</li>
                <li>Avaliação física detalhada</li>
                <li>Identificação de limitações funcionais</li>
                <li>Definição de objetivos realistas e mensuráveis</li>
                <li>Elaboração de um plano de tratamento personalizado</li>
              </ul>
              <div className="flex items-center text-lg font-semibold text-gray-900 mb-6">
                <span>Valor: €80</span>
                <span className="mx-2">|</span>
                <span>Duração: 60 minutos</span>
              </div>
              <Link
                href="/agenda"
                className="px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white font-medium rounded-md transition-colors duration-300 inline-block"
              >
                Agendar Avaliação
              </Link>
            </div>
            <div className="bg-gray-200 h-80 rounded-lg"></div>
          </div>
        </div>
      </section>
      
      <section className="py-16 bg-gray-50" id="sessao-individual">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div className="order-2 md:order-1 bg-gray-200 h-80 rounded-lg"></div>
            <div className="order-1 md:order-2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Sessão Individual</h2>
              <p className="text-lg text-gray-600 mb-4">
                As sessões individuais são personalizadas de acordo com suas necessidades específicas, identificadas durante a avaliação inicial. Utilizamos técnicas avançadas de fisioterapia para maximizar sua recuperação.
              </p>
              <p className="text-lg text-gray-600 mb-4">
                Cada sessão pode incluir:
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-600 space-y-2">
                <li>Exercícios terapêuticos específicos</li>
                <li>Técnicas manuais de mobilização</li>
                <li>Treino de equilíbrio e coordenação</li>
                <li>Reeducação da marcha</li>
                <li>Técnicas de facilitação neuromuscular</li>
                <li>Orientações para exercícios domiciliares</li>
              </ul>
              <div className="flex items-center text-lg font-semibold text-gray-900 mb-6">
                <span>Valor: €70</span>
                <span className="mx-2">|</span>
                <span>Duração: 50 minutos</span>
              </div>
              <Link
                href="/agenda"
                className="px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white font-medium rounded-md transition-colors duration-300 inline-block"
              >
                Agendar Sessão
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      <section className="py-16 bg-white" id="pacotes">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Pacotes com Desconto</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Para tratamentos contínuos, oferecemos pacotes de sessões com valores especiais, garantindo economia e resultados consistentes.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 transition-transform duration-300 hover:transform hover:scale-105">
              <div className="p-6 bg-teal-50 border-b border-gray-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Pacote Básico</h3>
                <div className="text-4xl font-bold text-teal-600 mb-4">€320</div>
                <p className="text-gray-600">5 sessões (€64 por sessão)</p>
              </div>
              <div className="p-6">
                <ul className="mb-6 space-y-4">
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-teal-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>5 sessões individuais de 50 minutos</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-teal-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Economia de €30</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-teal-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Validade de 2 meses</span>
                  </li>
                </ul>
                <Link
                  href="/pagamento?pacote=basico"
                  className="block w-full text-center px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white font-medium rounded-md transition-colors duration-300"
                >
                  Adquirir Pacote
                </Link>
              </div>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg overflow-hidden border-2 border-teal-500 transform scale-105 z-10">
              <div className="p-6 bg-teal-600 text-white border-b border-teal-700">
                <div className="absolute top-0 right-0 bg-yellow-400 text-xs font-bold uppercase px-3 py-1 rounded-bl-lg text-teal-800">
                  Mais Popular
                </div>
                <h3 className="text-2xl font-bold mb-2">Pacote Premium</h3>
                <div className="text-4xl font-bold mb-4">€600</div>
                <p>10 sessões (€60 por sessão)</p>
              </div>
              <div className="p-6">
                <ul className="mb-6 space-y-4">
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-teal-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>10 sessões individuais de 50 minutos</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-teal-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Economia de €100</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-teal-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Validade de 4 meses</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-teal-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Programa de exercícios domiciliares</span>
                  </li>
                </ul>
                <Link
                  href="/pagamento?pacote=premium"
                  className="block w-full text-center px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white font-medium rounded-md transition-colors duration-300"
                >
                  Adquirir Pacote
                </Link>
              </div>
            </div>
            
            <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 transition-transform duration-300 hover:transform hover:scale-105">
              <div className="p-6 bg-teal-50 border-b border-gray-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Pacote Família</h3>
                <div className="text-4xl font-bold text-teal-600 mb-4">€840</div>
                <p className="text-gray-600">15 sessões (€56 por sessão)</p>
              </div>
              <div className="p-6">
                <ul className="mb-6 space-y-4">
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-teal-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>15 sessões individuais de 50 minutos</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-teal-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Economia de €210</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-teal-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Validade de 6 meses</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-teal-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Transferível entre familiares</span>
                  </li>
                </ul>
                <Link
                  href="/pagamento?pacote=familia"
                  className="block w-full text-center px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white font-medium rounded-md transition-colors duration-300"
                >
                  Adquirir Pacote
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Specialized Services */}
      <section className="py-16 bg-gray-50" id="reabilitacao-neurologica">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Áreas de Especialização</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Oferecemos tratamentos especializados para diversas condições neurológicas e físicas.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Reabilitação Neurológica</h3>
              <p className="text-gray-600 mb-4">
                Tratamento especializado para pacientes com distúrbios neurológicos, incluindo:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-600 space-y-2">
                <li>AVC (Acidente Vascular Cerebral)</li>
                <li>Doença de Parkinson</li>
                <li>Esclerose Múltipla</li>
                <li>Traumatismo Cranioencefálico</li>
                <li>Lesões Medulares</li>
                <li>Neuropatias Periféricas</li>
              </ul>
              <p className="text-gray-600">
                Utilizamos técnicas avançadas de neuroreabilitação para melhorar a função motora, equilíbrio, coordenação e independência nas atividades diárias.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Reabilitação Física</h3>
              <p className="text-gray-600 mb-4">
                Tratamento para lesões musculoesqueléticas e condições ortopédicas, incluindo:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-600 space-y-2">
                <li>Lesões Desportivas</li>
                <li>Recuperação Pós-Cirúrgica</li>
                <li>Dores Lombares e Cervicais</li>
                <li>Tendinites e Bursites</li>
                <li>Artrose e Artrite</li>
                <li>Reabilitação após Fraturas</li>
              </ul>
              <p className="text-gray-600">
                Combinamos técnicas manuais, exercícios terapêuticos e modalidades físicas para reduzir a dor, melhorar a mobilidade e restaurar a função.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Fisioterapia Geriátrica</h3>
              <p className="text-gray-600 mb-4">
                Tratamento especializado para idosos, focado em:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-600 space-y-2">
                <li>Prevenção de Quedas</li>
                <li>Melhoria do Equilíbrio e Mobilidade</li>
                <li>Fortalecimento Muscular</li>
                <li>Manejo de Condições Crônicas</li>
                <li>Reabilitação após Hospitalização</li>
                <li>Orientação para Cuidadores</li>
              </ul>
              <p className="text-gray-600">
                Abordagem personalizada que considera as necessidades específicas dos idosos, visando melhorar a qualidade de vida e independência.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Fisioterapia Respiratória</h3>
              <p className="text-gray-600 mb-4">
                Tratamento para condições respiratórias, incluindo:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-600 space-y-2">
                <li>DPOC (Doença Pulmonar Obstrutiva Crônica)</li>
                <li>Asma</li>
                <li>Bronquite</li>
                <li>Pneumonia</li>
                <li>Recuperação Pós-COVID</li>
                <li>Fibrose Cística</li>
              </ul>
              <p className="text-gray-600">
                Técnicas de higiene brônquica, exercícios respiratórios e treinamento muscular respiratório para melhorar a função pulmonar e qualidade de vida.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* FAQ Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Perguntas Frequentes</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Respostas para as dúvidas mais comuns sobre nossos serviços.
            </p>
          </div>
          
          <div className="max-w-3xl mx-auto">
            <div className="space-y-6">
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Quanto tempo dura cada sessão?</h3>
                <p className="text-gray-600">
                  A avaliação inicial tem duração de 60 minutos, enquanto as sessões individuais regulares duram 50 minutos.
                </p>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Com que frequência devo fazer fisioterapia?</h3>
                <p className="text-gray-600">
                  A frequência das sessões varia de acordo com sua condição específica e objetivos. Após a avaliação inicial, será recomendado um plano de tratamento personalizado, que pode incluir sessões semanais, bissemanais ou com outra periodicidade.
                </p>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Os pacotes têm validade?</h3>
                <p className="text-gray-600">
                  Sim, o Pacote Básico tem validade de 2 meses, o Pacote Premium de 4 meses e o Pacote Família de 6 meses a partir da data de compra.
                </p>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Posso remarcar uma sessão?</h3>
                <p className="text-gray-600">
                  Sim, as sessões podem ser remarcadas com pelo menos 24 horas de antecedência, sem qualquer custo adicional. Cancelamentos com menos de 24 horas ou não comparecimento podem resultar na cobrança da sessão.
                </p>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Quais formas de pagamento são aceitas?</h3>
                <p className="text-gray-600">
                  Aceitamos pagamentos por cartão de crédito/débito, transferência bancária, MBWay e Multibanco.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-16 bg-teal-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">Pronto para iniciar sua jornada de recuperação?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Agende sua avaliação inicial e descubra como nossos tratamentos personalizados podem ajudar você a recuperar sua saúde e bem-estar.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/agenda"
              className="px-8 py-3 bg-white hover:bg-gray-100 text-teal-800 font-medium rounded-md transition-colors duration-300"
            >
              Agendar Consulta
            </Link>
            <Link
              href="/contato"
              className="px-8 py-3 bg-teal-600 hover:bg-teal-500 text-white border border-white font-medium rounded-md transition-colors duration-300"
            >
              Fale Conosco
            </Link>
          </div>
        </div>
      </section>
      
      <Footer />
    </main>
  );
}
